import { BiChevronDown } from "react-icons/bi";
import { CgMenu } from "react-icons/cg";
import React from "react";

interface Props {
  className?: string;
  children?: React.ReactNode;

  listeners?: any; // 👈 drag listeners
  setNodeRef?: any; // 👈 drag node ref
  attributes?: any; // 👈 drag attributes
}

export default function DragableLayout({
  className,
  children,

  listeners,
  setNodeRef,
  attributes,
}: Props) {
  const [open, setOpen] = React.useState(false);

  return (
    <div
      ref={setNodeRef}
      {...attributes}
      className={
        "w-full transition-all ease-in-out py-4 pr-4 shadow-md rounded-lg overflow-hidden relative flex   " +
        className
      }>
      <div
        {...listeners}
        className="cursor-move  flex items-startr justify-center px-4">
        <CgMenu className="text-2xl" />
      </div>

      {children}
    </div>
  );
}
